/**
 * @generated SignedSource<<408a6bbf37cb2ec70548f4f46aeb5107>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditViewInput = {
  description?: string | null | undefined;
  id: number;
  name?: string | null | undefined;
  peopleFilters?: any | null | undefined;
  projectFilters?: any | null | undefined;
  usersAllocated?: ReadonlyArray<number> | null | undefined;
};
export type ViewUpdateMutation$variables = {
  input: EditViewInput;
};
export type ViewUpdateMutation$data = {
  readonly editView: {
    readonly updatedView: {
      readonly databaseId: number;
      readonly description: string | null | undefined;
      readonly name: string;
      readonly peopleFilters: any;
      readonly projectFilters: any;
      readonly type: string;
      readonly userIds: ReadonlyArray<number>;
    };
  };
};
export type ViewUpdateMutation = {
  response: ViewUpdateMutation$data;
  variables: ViewUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectFilters",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "peopleFilters",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditViewPayload",
        "kind": "LinkedField",
        "name": "editView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DatabaseView",
            "kind": "LinkedField",
            "name": "updatedView",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditViewPayload",
        "kind": "LinkedField",
        "name": "editView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DatabaseView",
            "kind": "LinkedField",
            "name": "updatedView",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3f1ce1fbf4c3e439f2df06a685c5b19",
    "id": null,
    "metadata": {},
    "name": "ViewUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ViewUpdateMutation(\n  $input: EditViewInput!\n) {\n  editView(input: $input) {\n    updatedView {\n      databaseId\n      type\n      name\n      description\n      projectFilters\n      peopleFilters\n      userIds\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1dc88e711b10a35ae195f8ac3e2148e";

export default node;
